/* FAQ section (ss-faq-8) behaviour, moved out of the section's inline
 * <script> so it is cached and deferred. One copy serves every instance:
 * each section root carries data-ss-faq-8, data-section-id and
 * data-answer-padding-top. */
(function () {
  'use strict';
  if (window.__ssFaq8) return;
  window.__ssFaq8 = true;

  function initRoot(root) {
    if (root.dataset.faqInit) return;
    root.dataset.faqInit = 'true';
    var id = root.dataset.sectionId;
    var padTop = parseInt(root.dataset.answerPaddingTop || '0', 10);
    var all = function (cls) { return Array.prototype.slice.call(root.querySelectorAll('.' + cls + '-' + id)); };

    all('faq-button').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
      });
    });

    var buttons = all('faq-toggle');
    var answers = all('faq-answer');
    var measures = all('faq-height-cal');
    var icons = all('faq-arrow');
    var active = -1;

    function open(i) {
      var height = measures[i].offsetHeight;
      answers[i].style.display = 'block';
      if (buttons[i]) buttons[i].setAttribute('aria-expanded', 'true');
      window.setTimeout(function () {
        answers[i].style.paddingTop = padTop + 'px';
        answers[i].style.paddingBottom = '0px';
        answers[i].style.height = height + 'px';
        if (icons[i]) icons[i].style.setProperty('--rotate', '180deg');
      });
    }
    function close(i) {
      answers[i].style.paddingTop = 0;
      answers[i].style.paddingBottom = 0;
      answers[i].style.height = 0;
      if (icons[i]) icons[i].style.setProperty('--rotate', '0deg');
      if (buttons[i]) buttons[i].setAttribute('aria-expanded', 'false');
      window.setTimeout(function () { answers[i].style.display = 'none'; }, 300);
    }

    buttons.forEach(function (button, i) {
      button.addEventListener('click', function () {
        if (answers[i].style.display === 'none') { open(i); active = i; }
        else { close(i); active = -1; }
      });
    });

    var timer;
    window.addEventListener('resize', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (active !== -1) answers[active].style.height = measures[active].offsetHeight + 'px';
      }, 250);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ss-faq-8]').forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
